const initialState = {
	isStarted: false,
	loading: 0,
	feedback: {
		message: null,
		color: 'success',
		hideDuration: 2000,
	}
}

// REDUCERS
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'setStarted@ui': {
			return {
				...state,
				isStarted: true,
			}
		}
		case 'startLoad@ui': {
			return {
				...state,
				loading: state.loading + 1,
			}
		}
		case 'stopLoad@ui': {
			return {
				...state,
				loading: state.loading - 1,
			}
		}

		case 'setFeedback@ui': {
			const duration = action.hideDuration == undefined ? 2000 : action.hideDuration == 0 ? null : action.hideDuration
			return {
				...state,
				feedback: {
					message: action.message,
					color: action.color || 'success',
					hideDuration: duration,
				}
			}
		}

		default: return state
	}
}
